import * as Yup from 'yup';

export default Yup.object().shape({
  saleProductKey: Yup.string()
    .required('SCHEMA_ERRORS.REQUIRED_VALUE'),
});
